import React from "react";
import "./index.css";

export default ({ children, title, description, subtitle, number, icon, steps, step, overflow }) => {

    return(
        <div className="dashboard-section-base-container margin-top-2x" style={overflow ? { overflow: "hidden" } : {}}>
            {steps &&
                <div className="dashboard-section-steps-container">
                    {renderSteps(steps, step)}
                </div>
            }
            <div className="dashboard-section-base-header">
                {number &&
                    <div className="dashboard-section-base-number" aria-hidden="true">{number}</div>
                }
                <div className="dashboard-section-base-header-content">
                    <div className="dashboard-section-base-title-contianer">
                        <p className="dashboard-section-base-title">{title}</p>
                        {icon &&
                            <img src={icon} alt="" />
                        }
                    </div>
                    {subtitle &&
                        <p className="dashboard-section-base-subtitle">{subtitle}</p>
                    }
                    {description &&
                        <div className="dashboard-section-base-description-contianer margin-top-20px">
                            <p className="dashboard-section-base-description">{description}</p>
                        </div>
                    }
                </div>
            </div>
            <div className="dashboard-section-base-body">
                {children}
            </div>
        </div>
    );

}

const renderSteps = (steps, step) => {

    return steps.map((current, index) => {
        return(
            <div className="dashboard-section-items-container" key={index}>
                <div className="dashboard-section-steps-item-container" style={current <= step ? {backgroundColor: "var(--jc-coral-500)"} : {backgroundColor: "var(--jc-ink-100)"}}>
                </div>
                {index < steps.length-1 &&
                    <div className="dashboard-section-steps-items-separator">
                    </div>
                }
            </div>
        );
    });

}
